<template>
  <div class="home-page">
    <header-pane
      class="home-page__header"
      colorType="light"
      :pageTitle="$tc('HomePage.pageTitle')"
    />

    <home-pane />

    <global-navigation-pane current="home" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import HeaderPane from '@/components/common/Header/HeaderPane.vue'
import GlobalNavigationPane from '@/components/common/GlobalNavigation/GlobalNavigationPane.vue'
import HomePane from '@/components/HomePage/HomePane.vue'

/**
 * HOME ページ
 */
export default defineComponent({
  name: 'HomePage',
  components: {
    HeaderPane,
    GlobalNavigationPane,
    HomePane,
  },
})
</script>

<style lang="scss" scoped>
.home-page {
  background: $gray1;
  min-height: var(--screen-height);
  padding-bottom: var(--safe-area-inset-bottom);
}
</style>
